export default "__VITE_ASSET__DF_67d19__"